import DataQuery from 'data/DataQuery';
import { Accounts_Get } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import React, { useState } from 'react';
import AccountFullDTO from 'features/accounts/dtos/AccountFullDTO';
import AccountInfoCard from 'features/accounts/components/AccountInfoCard';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import AccountRolesSection from 'features/accounts/sections/AccountRolesSection';
import AccountRestrictionsSection from 'features/accounts/sections/AccountRestrictionsSection';
import { getForAdminParam } from 'features/shared/helpers/queryParams';

interface Props {
  accountId: string;
  forAdminUse?: boolean;
}

const AccountDetailSection = ({ accountId, forAdminUse = false }: Props) => {
  // state
  const [accountModified, setAccountModified] = useState(0);

  // fetch data
  const query: DataQuery = {
    url: Accounts_Get,
    routeParams: getRouteParams("accountId", accountId),
    params: getForAdminParam(forAdminUse)
  };
  const { data: account, loadStatus } = useQuery<AccountFullDTO>(query, {}, [accountId, accountModified]);

  // render
  return (
    <NoContentWrapper
      data={account}
      loadStatus={loadStatus}
      noContentAsAlert
    >
      <AccountInfoCard account={account} />
      <div className="row no-gutters mx-n2">
        <div className="col-sm-6 px-2">
          <AccountRolesSection account={account} 
          accountModified={accountModified}
          setAccountModified={setAccountModified}
          forAdminUse={forAdminUse}
        />
        </div>
        <div className="col-sm-6 px-2">
          <AccountRestrictionsSection 
            account={account} 
            accountModified={accountModified}
            setAccountModified={setAccountModified}
            forAdminUse={forAdminUse}
          />
        </div>
      </div>
    </NoContentWrapper>
  )
}

export default AccountDetailSection;
